module.exports = __webpack_public_path__ + "static/media/intro-en-de.3c611d2e.vtt";